/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_CardInputs */

const en_guide_json_schema_card = /** @type {(inputs: Guide_Json_Schema_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validate your JSON data with JSON Schema. Learn types, required fields, and constraints.`)
};

const ko_guide_json_schema_card = /** @type {(inputs: Guide_Json_Schema_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema로 JSON 데이터를 검증하세요. 타입, 필수 필드, 제약 조건을 배워보세요.`)
};

const ja_guide_json_schema_card = /** @type {(inputs: Guide_Json_Schema_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schemaでデータを検証。型、必須フィールド、制約を学びましょう。`)
};

/**
* | output |
* | --- |
* | "Validate your JSON data with JSON Schema. Learn types, required fields, and constraints." |
*
* @param {Guide_Json_Schema_CardInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_card = /** @type {((inputs?: Guide_Json_Schema_CardInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_CardInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_card(inputs)
	if (locale === "ko") return ko_guide_json_schema_card(inputs)
	return ja_guide_json_schema_card(inputs)
});